import { Component } from '@angular/core';

@Component({
  selector: 'app-document-check-icon',
  imports: [],
  templateUrl: './document-check-icon.html',
  styleUrl: './document-check-icon.scss',
})
export class DocumentCheckIcon {

}
